import { env } from '@/src/env'
import { usePostHog } from 'posthog-js/react'
import { useSessionStore } from '../../hooks/use_session_store'

// TODO: Check to remove this
export const getHighestLevelCompanyInfo = (companyId: string, companyName: string) => {
  const infoObject = {
    name: companyName,
    id: companyId,
  }

  return infoObject
}

const registerPosthogLogin = async (event, posthog) => {
  const { userId, email, companyId, companyName, organizationId } = event
  const user = { id: userId, email, companyName }

  const highestLevelCompanyInfo = getHighestLevelCompanyInfo(companyId, companyName)

  posthog.identify(user.id, { email })

  const payload = {
    name: highestLevelCompanyInfo.name,
  }

  posthog.group('company', highestLevelCompanyInfo.id, payload)
  if (organizationId) {
    posthog.group('organization', organizationId, payload)
  }

  const { nodeEnv } = env
  if (nodeEnv) {
    posthog.group('environment', nodeEnv, { name: nodeEnv })
  }

  posthog.capture('Signed In')
}

export const useProductAnalytics = () => {
  const posthog = usePostHog()
  const { user } = useSessionStore()

  const reportEvent = async (eventName, optPayload?: any) => {
    if (user && posthog) {
      const highestLevelCompanyInfo = getHighestLevelCompanyInfo(user.companyId, user.companyName)
      const payload = {
        name: highestLevelCompanyInfo.name,
        payload: optPayload,
      }

      posthog.identify(user.id, { email: user.email })
      posthog.group('company', highestLevelCompanyInfo.id, payload)
      if (user.organizationId) {
        posthog.group('organization', user.organizationId, payload)
      }

      posthog.capture(eventName, { organisation_id: user.organizationId, ...optPayload })
    }
  }

  return { reportEvent }
}

export { registerPosthogLogin }
